// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function andMap(wrappedValue, wrappedFunction) {
  var exit = 0;
  var exit$1 = 0;
  if (typeof wrappedFunction === "number") {
    exit$1 = 3;
  } else {
    switch (wrappedFunction.TAG | 0) {
      case /* Loading */0 :
          exit$1 = 3;
          break;
      case /* Failure */1 :
          return {
                  TAG: /* Failure */1,
                  _0: wrappedFunction._0
                };
      case /* Success */2 :
          if (typeof wrappedValue !== "number") {
            switch (wrappedValue.TAG | 0) {
              case /* Loading */0 :
                  break;
              case /* Failure */1 :
                  exit$1 = 3;
                  break;
              case /* Success */2 :
                  return {
                          TAG: /* Success */2,
                          _0: Curry._1(wrappedFunction._0, wrappedValue._0)
                        };
              
            }
          }
          break;
      
    }
  }
  if (exit$1 === 3) {
    if (typeof wrappedValue === "number") {
      exit = 2;
    } else {
      if (wrappedValue.TAG === /* Failure */1) {
        return {
                TAG: /* Failure */1,
                _0: wrappedValue._0
              };
      }
      exit = 2;
    }
  }
  if (exit === 2 && typeof wrappedFunction !== "number") {
    return {
            TAG: /* Loading */0,
            _0: wrappedFunction._0
          };
  }
  if (typeof wrappedValue === "number" || wrappedValue.TAG !== /* Loading */0) {
    return /* NotAsked */0;
  } else {
    return {
            TAG: /* Loading */0,
            _0: wrappedValue._0
          };
  }
}

function map(f, data) {
  if (typeof data === "number") {
    return /* NotAsked */0;
  }
  switch (data.TAG | 0) {
    case /* Loading */0 :
        return {
                TAG: /* Loading */0,
                _0: data._0
              };
    case /* Failure */1 :
        return {
                TAG: /* Failure */1,
                _0: data._0
              };
    case /* Success */2 :
        return {
                TAG: /* Success */2,
                _0: Curry._1(f, data._0)
              };
    
  }
}

function map2(f, a, b) {
  return andMap(b, map(f, a));
}

function map3(f, a, b, c) {
  return andMap(c, andMap(b, map(f, a)));
}

function mapError(f, data) {
  if (typeof data === "number") {
    return /* NotAsked */0;
  }
  switch (data.TAG | 0) {
    case /* Loading */0 :
        return {
                TAG: /* Loading */0,
                _0: data._0
              };
    case /* Failure */1 :
        return {
                TAG: /* Failure */1,
                _0: Curry._1(f, data._0)
              };
    case /* Success */2 :
        return {
                TAG: /* Success */2,
                _0: data._0
              };
    
  }
}

function mapBoth(successFn, errorFn) {
  return function (param) {
    return mapError(errorFn, map(successFn, param));
  };
}

function andThen(f, data) {
  if (typeof data === "number") {
    return /* NotAsked */0;
  }
  switch (data.TAG | 0) {
    case /* Loading */0 :
        return {
                TAG: /* Loading */0,
                _0: data._0
              };
    case /* Failure */1 :
        return {
                TAG: /* Failure */1,
                _0: data._0
              };
    case /* Success */2 :
        return Curry._1(f, data._0);
    
  }
}

function withDefault($$default, data) {
  if (typeof data === "number" || data.TAG !== /* Success */2) {
    return $$default;
  } else {
    return data._0;
  }
}

function fromResult(x) {
  if (x.TAG === /* Ok */0) {
    return {
            TAG: /* Success */2,
            _0: x._0
          };
  } else {
    return {
            TAG: /* Failure */1,
            _0: x._0
          };
  }
}

function toOption(a) {
  if (typeof a === "number" || a.TAG !== /* Success */2) {
    return ;
  } else {
    return Caml_option.some(a._0);
  }
}

function append(a, b) {
  return andMap(b, map((function (a, b) {
                    return [
                            a,
                            b
                          ];
                  }), a));
}

function succeed(a) {
  return {
          TAG: /* Success */2,
          _0: a
        };
}

function isSuccess(_a) {
  if (typeof _a === "number" || _a.TAG !== /* Success */2) {
    return false;
  } else {
    return true;
  }
}

function isFailure(_e) {
  if (typeof _e === "number" || _e.TAG !== /* Failure */1) {
    return false;
  } else {
    return true;
  }
}

function isLoading(param) {
  if (typeof param === "number" || param.TAG !== /* Loading */0) {
    return false;
  } else {
    return true;
  }
}

function isNotAsked(param) {
  if (typeof param === "number") {
    return true;
  } else {
    return false;
  }
}

exports.andMap = andMap;
exports.map = map;
exports.map2 = map2;
exports.map3 = map3;
exports.mapError = mapError;
exports.mapBoth = mapBoth;
exports.andThen = andThen;
exports.withDefault = withDefault;
exports.fromResult = fromResult;
exports.toOption = toOption;
exports.append = append;
exports.succeed = succeed;
exports.isSuccess = isSuccess;
exports.isFailure = isFailure;
exports.isLoading = isLoading;
exports.isNotAsked = isNotAsked;
/* No side effect */
